<template>
    <div
        v-if="average && total && total > 4"
        class="product-rating-title d-flex align-center"
        :class="{
            'justify-center': compact
        }"
    >
        <StarRating
            :rating="average"
            :increment="0.1"
            :show-rating="false"
            :star-size="14"
            :gap="4"
            :rounded-corners="true"
            active-color="#333"
            border-color="#333"
            inactive-color="#fff"
            :border-width="2"
            readonly
        ></StarRating>
        <div
            class="font-size-7 ml-2"
        >
            {{ average }} Rating <template
                v-if="!hideTotal"
            >
                (<span>{{ total }} Review<template v-if="total > 1">s</template></span>)
            </template>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import StarRating from 'x1-base/components/star-rating/StarRating/StarRating.vue';

    withDefaults(
        defineProps<{
            average: Nilish<number>;
            total: Nilish<number>;
            compact?: boolean;
            hideTotal?: boolean;
        }>(),
        {
            compact: false
        }
    );
</script>

<style lang="scss"></style>
